import script from "./totalCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./totalCard.vue?vue&type=script&setup=true&lang=ts"

import "./totalCard.vue?vue&type=style&index=0&id=6c9949e0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c9949e0"]])

export default __exports__